var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import { classNames } from '@shapeable/utils';
var cls = classNames('menu-section-link');
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from './icon';
import { useLink } from '../hooks/use-link';
import { useMenu } from '../hooks/use-menu';
import { ChevronRightIconGlyph } from '@shapeable/icons';
export var MenuSectionLinkDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n  "])))
});
var DotStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 8px;\n    min-width: 12px;\n    min-height: 12px;\n    display: flex;\n    border-radius: 50%;\n    margin-right: ", ";\n    margin-left: 2px;\n\n    ", "\n  "], ["\n    font-size: 8px;\n    min-width: 12px;\n    min-height: 12px;\n    display: flex;\n    border-radius: 50%;\n    margin-right: ", ";\n    margin-left: 2px;\n\n    ", "\n  "])), theme.UNIT(3), function (_a) {
    var _color = _a._color;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background-color: ", ";\n      \n    "], ["\n      background-color: ", ";\n      \n    "])), _color);
  })
});
var LabelStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", "em;\n    font-weight: 400;\n    color: ", ";\n  "], ["\n    font-family: ", ";\n    font-size: ", "em;\n    font-weight: 400;\n    color: ", ";\n  "])), theme.FONT('serif'), 18 / 12, theme.COLOR('strong'))
});
var IconStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""]))),
  Label: styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Icon: styled(Icon)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
My.Container = styled.span(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", ";\n\n  &:hover {\n    ", ";\n    ", " {\n      color: ", ";\n    }\n  }\n"], ["\n  ", ";\n\n  &:hover {\n    ", ";\n    ", " {\n      color: ", ";\n    }\n  }\n"])), ContainerStyles, theme.FILL('primary'), My.Label, theme.COLOR('primary'));
export var MenuSectionLink = function (props) {
  var className = props.className,
    section = props.section;
  var menu = useMenu();
  var Link = useLink().Link;
  var linkStyle = {
    textDecoration: 'none'
  };
  return React.createElement(Link, {
    onClick: menu.hideOnClick,
    href: section.path,
    style: linkStyle
  }, React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Label, null, section.name), React.createElement(My.Icon, {
    size: 16
  }, React.createElement(ChevronRightIconGlyph, null))));
};
MenuSectionLink.defaultProps = MenuSectionLinkDefaultProps;
MenuSectionLink.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;